export const TOKEN = (env: string): string => {
  return `token_${env}`;
};

export const REFRESH_TOKEN = (env: string): string => {
  return `refreshToken_${env}`;
};
